import React, { useEffect, useState } from "react";
import { 
    Outlet,
    useNavigate
} from "react-router-dom";

// 👉 MUI imports
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import MuiDrawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

// 👉 Local components
import MobileHeader from "./mobile/header";
import MobileNav from "./mobile/nav";
import DesktopHeader from "./desktop/header";
import DesktopNav from "./desktop/nav";

// import getApiData from '../../hooks/apiRequests/getRequest';
import signUserOut from '../../hooks/authManagement/signout';
import getApiData from '../../hooks/apiRequests/getRequest';
import { clearSessionToken } from '../../hooks/authManagement/sessionToken';
import { DrawerHeader } from "./common/utils";
import { useToast } from "../shared/toastMessages/toastProvider";

import {theme} from '../../configs/theme';

function Portal() {
  const [headerData, setHeaderData] = useState();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 650);
  const { showToast } = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 650);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getApiData(`/HeaderData`);
        setHeaderData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        clearSessionToken();
        showToast("Failed to load data. Redirecting to login...", "error");
        navigate('/');
      }
    };

    fetchData();
  }, [ navigate, showToast]);

  const logoutUser = async () => {
    try {
      const response = await signUserOut();
      setHeaderData(response.data);
    } catch (error) {
      console.error('Error fetching post data:', error);
    }
  };

  const [drawerOpen, setDrawerOpen] = useState(false);
  const openDrawer = () => setDrawerOpen(true);
  const closeDrawer = () => setDrawerOpen(false);

  if (isMobile) {
    return (
      <>
        <MobileHeader drawerOpen={drawerOpen} openDrawer={openDrawer} headerData={headerData} logoutUser={logoutUser} theme={theme}/>
        <MuiDrawer
          variant="temporary"
          open={drawerOpen}
          onClose={closeDrawer}
          ModalProps={{ keepMounted: true }}
        >
        <DrawerHeader>
          <IconButton onClick={closeDrawer}>
            {theme.direction === "rtl" ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <MobileNav drawerOpen={drawerOpen} closeDrawer={closeDrawer} theme={theme} headerData={headerData} />
      </MuiDrawer>
        <Box component="main" sx={{ p: 2, background:'#ebeff2', minHeight: '100vh' }}>
          <DrawerHeader />
          <Outlet headerData={headerData}/>
        </Box>
      </>
    );
  }

  return (
    <Box sx={{ display: "flex", backgroundColor:'#dbdbdbff', height:'100vh'}}>
      <CssBaseline />
      <DesktopHeader drawerOpen={drawerOpen} openDrawer={openDrawer} logoutUser={logoutUser} headerData={headerData}/>
      <DesktopNav drawerOpen={drawerOpen} closeDrawer={closeDrawer} theme={theme}/>
      <Box component="main" sx={{ flexGrow: 1, p: 3, backgroundColor:'#dbdbdbff', height:'fit-content' }}>
        <DrawerHeader />
        <Outlet headerData={headerData}/>
      </Box>
    </Box>
  );
}

export default Portal;
